export const RESET = 'RESET';
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCEEDED = 'LOGIN_SUCCEEDED';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGOUT = 'LOGOUT';

export const REFRESH_PERMISSIONS = 'REFRESH_PERMISSIONS';
export const REFRESH_PERMISSIONS_SUCCEEDED = 'REFRESH_PERMISSIONS_SUCCEEDED';
export const REFRESH_PERMISSIONS_FAILED = 'REFRESH_PERMISSIONS_FAILED';
